/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, shape, string, arrayOf, func,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import { useUIDSeed } from 'react-uid';
import { Link } from 'react-router-dom';

const styles = ()  => ({
    tileBlock: {
        maxWidth: 980,
        width: '100%',
        margin: '15px auto',
    },
    tileImage: {
        position: 'relative',
        padding: '0 10px',
        '& img': {
            width: '100%',
        },
    },
    tileTitle: {
        textAlign: 'center',
        fontSize: 18,
        fontWeight: 600,
        textTransform: 'uppercase',
    },
    tileText: {
        textAlign: 'center',
        fontSize: 13,
    },
    textGrid: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        alignItems: 'center',
        width: 130,
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
    },
});
const TileBlock = (classes, image, link, text, textStyle, block) => {
    const seed = useUIDSeed();
    return (
        <Grid key={seed(block)} item xs={12} md={4} lg={4} className={classes.tileImage}>
            <Link className={classes.link} style={textStyle} href={link?.href}>
                <img src={image?.url} alt={link?.title} />
                <div className={classes.textGrid}>
                    <div>
                        <div className={classes.tileTitle}>{link?.title}</div>
                        <div className={classes.tileText}>{text}</div>
                    </div>
                </div>
            </Link>
        </Grid>
    );
};
const SimpleTile = ({ classes, data, fontFamily }) => {
    const simpleTileBlock = data?.tile || [];
    const fontColor  = data?.styles?.font_color?.color || '#ffffff';
    const textStyle = {
        color: fontColor,
        fontFamily: fontFamily(data?.styles?.font_family) || '',
    };
    return (
        <div className={classes.tileBlock}>
            <Grid container>
                {simpleTileBlock.map((block) => TileBlock(classes, block?.image, block?.link, block?.text, textStyle, block))}
            </Grid>
        </div>
    );
};
SimpleTile.propTypes = {
    classes: object.isRequired,
    data: shape({
        simple_tile_row: shape({
            styles: shape({
                font_color: shape({
                    color: string,
                }),
            }),
        }),
        tile: arrayOf(shape({
            image: shape({
                url: string,
            }),
            link: shape({
                title: string,
                href: string,
            }),
            text: string,
        })),
    }).isRequired,
    fontFamily: func.isRequired,
};

export default withStyles(styles)(SimpleTile);
